"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/message/v1/cms_service.proto (package spwn.message.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSMessageServiceGetNumberOfUnreadMessagesResponse = exports.CMSMessageServiceGetNumberOfUnreadMessagesRequest = exports.CMSMessageServiceGetBrandDmNotificationSettingResponse = exports.CMSMessageServiceGetBrandDmNotificationSettingRequest = exports.CMSMessageServiceUpdateBrandDmNotificationSettingResponse = exports.CMSMessageServiceUpdateBrandDmNotificationSettingRequest = exports.CMSMessageServiceGetSignedUrlForFileUploadResponse = exports.CMSMessageServiceGetSignedUrlForFileUploadRequest = exports.CMSMessageServicePostDMMessagesToCoreFansFromCreatorResponse = exports.CMSMessageServicePostDMMessagesToCoreFansFromCreatorRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const cms_common_pb_1 = require("./cms_common_pb");
/**
 * @generated from message spwn.message.v1.CMSMessageServicePostDMMessagesToCoreFansFromCreatorRequest
 */
class CMSMessageServicePostDMMessagesToCoreFansFromCreatorRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.message.v1.CMSMessageCoreFanFilterIncludeOrExclude include_or_exclude = 2;
         */
        this.includeOrExclude = cms_common_pb_1.CMSMessageCoreFanFilterIncludeOrExclude.CMS_MESSAGE_CORE_FAN_FILTER_INCLUDE_OR_EXCLUDE_UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSMessageServicePostDMMessagesToCoreFansFromCreatorRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSMessageServicePostDMMessagesToCoreFansFromCreatorRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSMessageServicePostDMMessagesToCoreFansFromCreatorRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSMessageServicePostDMMessagesToCoreFansFromCreatorRequest, a, b);
    }
}
exports.CMSMessageServicePostDMMessagesToCoreFansFromCreatorRequest = CMSMessageServicePostDMMessagesToCoreFansFromCreatorRequest;
CMSMessageServicePostDMMessagesToCoreFansFromCreatorRequest.runtime = protobuf_1.proto3;
CMSMessageServicePostDMMessagesToCoreFansFromCreatorRequest.typeName = "spwn.message.v1.CMSMessageServicePostDMMessagesToCoreFansFromCreatorRequest";
CMSMessageServicePostDMMessagesToCoreFansFromCreatorRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "dm_message", kind: "message", T: cms_common_pb_1.CMSMessageDmMessage },
    { no: 2, name: "include_or_exclude", kind: "enum", T: protobuf_1.proto3.getEnumType(cms_common_pb_1.CMSMessageCoreFanFilterIncludeOrExclude) },
]);
/**
 * @generated from message spwn.message.v1.CMSMessageServicePostDMMessagesToCoreFansFromCreatorResponse
 */
class CMSMessageServicePostDMMessagesToCoreFansFromCreatorResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSMessageServicePostDMMessagesToCoreFansFromCreatorResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSMessageServicePostDMMessagesToCoreFansFromCreatorResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSMessageServicePostDMMessagesToCoreFansFromCreatorResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSMessageServicePostDMMessagesToCoreFansFromCreatorResponse, a, b);
    }
}
exports.CMSMessageServicePostDMMessagesToCoreFansFromCreatorResponse = CMSMessageServicePostDMMessagesToCoreFansFromCreatorResponse;
CMSMessageServicePostDMMessagesToCoreFansFromCreatorResponse.runtime = protobuf_1.proto3;
CMSMessageServicePostDMMessagesToCoreFansFromCreatorResponse.typeName = "spwn.message.v1.CMSMessageServicePostDMMessagesToCoreFansFromCreatorResponse";
CMSMessageServicePostDMMessagesToCoreFansFromCreatorResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.message.v1.CMSMessageServiceGetSignedUrlForFileUploadRequest
 */
class CMSMessageServiceGetSignedUrlForFileUploadRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * ファイル名
         *
         * @generated from field: string filename = 1;
         */
        this.filename = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSMessageServiceGetSignedUrlForFileUploadRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSMessageServiceGetSignedUrlForFileUploadRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSMessageServiceGetSignedUrlForFileUploadRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSMessageServiceGetSignedUrlForFileUploadRequest, a, b);
    }
}
exports.CMSMessageServiceGetSignedUrlForFileUploadRequest = CMSMessageServiceGetSignedUrlForFileUploadRequest;
CMSMessageServiceGetSignedUrlForFileUploadRequest.runtime = protobuf_1.proto3;
CMSMessageServiceGetSignedUrlForFileUploadRequest.typeName = "spwn.message.v1.CMSMessageServiceGetSignedUrlForFileUploadRequest";
CMSMessageServiceGetSignedUrlForFileUploadRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.message.v1.CMSMessageServiceGetSignedUrlForFileUploadResponse
 */
class CMSMessageServiceGetSignedUrlForFileUploadResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * アップロードされたファイルのID
         *
         * @generated from field: string media_id = 1;
         */
        this.mediaId = "";
        /**
         * アップロード時に指定するヘッダー
         *
         * @generated from field: map<string, string> headers_for_upload = 2;
         */
        this.headersForUpload = {};
        /**
         * アップロード用のURL
         *
         * @generated from field: string url_for_upload = 3;
         */
        this.urlForUpload = "";
        /**
         * ダウンロード用のURL
         *
         * @generated from field: string url_for_download = 4;
         */
        this.urlForDownload = "";
        /**
         * S3 bucket内でのobjectに対するpath
         *
         * @generated from field: string s3_object_path = 5;
         */
        this.s3ObjectPath = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSMessageServiceGetSignedUrlForFileUploadResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSMessageServiceGetSignedUrlForFileUploadResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSMessageServiceGetSignedUrlForFileUploadResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSMessageServiceGetSignedUrlForFileUploadResponse, a, b);
    }
}
exports.CMSMessageServiceGetSignedUrlForFileUploadResponse = CMSMessageServiceGetSignedUrlForFileUploadResponse;
CMSMessageServiceGetSignedUrlForFileUploadResponse.runtime = protobuf_1.proto3;
CMSMessageServiceGetSignedUrlForFileUploadResponse.typeName = "spwn.message.v1.CMSMessageServiceGetSignedUrlForFileUploadResponse";
CMSMessageServiceGetSignedUrlForFileUploadResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "headers_for_upload", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
    { no: 3, name: "url_for_upload", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "url_for_download", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "s3_object_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.message.v1.CMSMessageServiceUpdateBrandDmNotificationSettingRequest
 */
class CMSMessageServiceUpdateBrandDmNotificationSettingRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool is_checked = 1;
         */
        this.isChecked = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSMessageServiceUpdateBrandDmNotificationSettingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSMessageServiceUpdateBrandDmNotificationSettingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSMessageServiceUpdateBrandDmNotificationSettingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSMessageServiceUpdateBrandDmNotificationSettingRequest, a, b);
    }
}
exports.CMSMessageServiceUpdateBrandDmNotificationSettingRequest = CMSMessageServiceUpdateBrandDmNotificationSettingRequest;
CMSMessageServiceUpdateBrandDmNotificationSettingRequest.runtime = protobuf_1.proto3;
CMSMessageServiceUpdateBrandDmNotificationSettingRequest.typeName = "spwn.message.v1.CMSMessageServiceUpdateBrandDmNotificationSettingRequest";
CMSMessageServiceUpdateBrandDmNotificationSettingRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "is_checked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.message.v1.CMSMessageServiceUpdateBrandDmNotificationSettingResponse
 */
class CMSMessageServiceUpdateBrandDmNotificationSettingResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSMessageServiceUpdateBrandDmNotificationSettingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSMessageServiceUpdateBrandDmNotificationSettingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSMessageServiceUpdateBrandDmNotificationSettingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSMessageServiceUpdateBrandDmNotificationSettingResponse, a, b);
    }
}
exports.CMSMessageServiceUpdateBrandDmNotificationSettingResponse = CMSMessageServiceUpdateBrandDmNotificationSettingResponse;
CMSMessageServiceUpdateBrandDmNotificationSettingResponse.runtime = protobuf_1.proto3;
CMSMessageServiceUpdateBrandDmNotificationSettingResponse.typeName = "spwn.message.v1.CMSMessageServiceUpdateBrandDmNotificationSettingResponse";
CMSMessageServiceUpdateBrandDmNotificationSettingResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.message.v1.CMSMessageServiceGetBrandDmNotificationSettingRequest
 */
class CMSMessageServiceGetBrandDmNotificationSettingRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSMessageServiceGetBrandDmNotificationSettingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSMessageServiceGetBrandDmNotificationSettingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSMessageServiceGetBrandDmNotificationSettingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSMessageServiceGetBrandDmNotificationSettingRequest, a, b);
    }
}
exports.CMSMessageServiceGetBrandDmNotificationSettingRequest = CMSMessageServiceGetBrandDmNotificationSettingRequest;
CMSMessageServiceGetBrandDmNotificationSettingRequest.runtime = protobuf_1.proto3;
CMSMessageServiceGetBrandDmNotificationSettingRequest.typeName = "spwn.message.v1.CMSMessageServiceGetBrandDmNotificationSettingRequest";
CMSMessageServiceGetBrandDmNotificationSettingRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.message.v1.CMSMessageServiceGetBrandDmNotificationSettingResponse
 */
class CMSMessageServiceGetBrandDmNotificationSettingResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool is_checked = 1;
         */
        this.isChecked = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSMessageServiceGetBrandDmNotificationSettingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSMessageServiceGetBrandDmNotificationSettingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSMessageServiceGetBrandDmNotificationSettingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSMessageServiceGetBrandDmNotificationSettingResponse, a, b);
    }
}
exports.CMSMessageServiceGetBrandDmNotificationSettingResponse = CMSMessageServiceGetBrandDmNotificationSettingResponse;
CMSMessageServiceGetBrandDmNotificationSettingResponse.runtime = protobuf_1.proto3;
CMSMessageServiceGetBrandDmNotificationSettingResponse.typeName = "spwn.message.v1.CMSMessageServiceGetBrandDmNotificationSettingResponse";
CMSMessageServiceGetBrandDmNotificationSettingResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "is_checked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.message.v1.CMSMessageServiceGetNumberOfUnreadMessagesRequest
 */
class CMSMessageServiceGetNumberOfUnreadMessagesRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSMessageServiceGetNumberOfUnreadMessagesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSMessageServiceGetNumberOfUnreadMessagesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSMessageServiceGetNumberOfUnreadMessagesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSMessageServiceGetNumberOfUnreadMessagesRequest, a, b);
    }
}
exports.CMSMessageServiceGetNumberOfUnreadMessagesRequest = CMSMessageServiceGetNumberOfUnreadMessagesRequest;
CMSMessageServiceGetNumberOfUnreadMessagesRequest.runtime = protobuf_1.proto3;
CMSMessageServiceGetNumberOfUnreadMessagesRequest.typeName = "spwn.message.v1.CMSMessageServiceGetNumberOfUnreadMessagesRequest";
CMSMessageServiceGetNumberOfUnreadMessagesRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.message.v1.CMSMessageServiceGetNumberOfUnreadMessagesResponse
 */
class CMSMessageServiceGetNumberOfUnreadMessagesResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 number_of_unread = 1;
         */
        this.numberOfUnread = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSMessageServiceGetNumberOfUnreadMessagesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSMessageServiceGetNumberOfUnreadMessagesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSMessageServiceGetNumberOfUnreadMessagesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSMessageServiceGetNumberOfUnreadMessagesResponse, a, b);
    }
}
exports.CMSMessageServiceGetNumberOfUnreadMessagesResponse = CMSMessageServiceGetNumberOfUnreadMessagesResponse;
CMSMessageServiceGetNumberOfUnreadMessagesResponse.runtime = protobuf_1.proto3;
CMSMessageServiceGetNumberOfUnreadMessagesResponse.typeName = "spwn.message.v1.CMSMessageServiceGetNumberOfUnreadMessagesResponse";
CMSMessageServiceGetNumberOfUnreadMessagesResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "number_of_unread", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
//# sourceMappingURL=cms_service_pb.js.map